import { Component, forwardRef, Provider } from '@angular/core';
import {
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { FormField } from '@shared/models/formfield';

export const fieldsToForm = (fields: FormField[], initialValues?: any) => {
  const form = new FormGroup({});
  for (const field of fields) {
    const control = new FormControl(
      initialValues[field.fieldName],
      field.required ? Validators.required : null
    );
    form.addControl(field.fieldName, control);
  }

  return form;
};

export const matches = (el: any, selector: string) =>
  (el.matches || el.msMatchesSelector).call(el, selector);

export const updateChanged = (toUpdate: any, changes: any) => {
  const objCopy = { ...toUpdate };

  for (const key in changes) {
    if (toUpdate.hasOwnProperty(key)) {
      if (typeof toUpdate[key] === 'object' && toUpdate[key] !== null) {
        updateChanged(toUpdate[key], changes[key]);
      } else {
        if (toUpdate[key] !== changes[key]) {
          toUpdate[key] = changes[key];
        }
      }
    }
  }
  return objCopy;
};

export const removeNullValues = <T>(obj: T): Partial<T> => {
  console.assert(!!obj, 'No object provided');
  let o = Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
  return o as Partial<T>;
};

export const objectToFormData = (
  obj: any,
  form?: FormData,
  namespace?: string
) => {
  var fd = form || new FormData();
  var formKey;

  for (const property in obj) {
    console.log('prop', property);
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File)
      ) {
        objectToFormData(obj[property], fd, property);
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  }

  return fd;
};

export const flattenObj = (ob: any) => {
  // The object which contains the
  // final result
  let result: any = {};

  // loop through the object "ob"
  for (const i in ob) {
    // We check the type of the i using
    // typeof() function and recursively
    // call the function again
    if (typeof ob[i] === 'object' && !Array.isArray(ob[i])) {
      const temp = flattenObj(ob[i]);
      for (const j in temp) {
        // Store temp in result
        result[i + '.' + j] = temp[j];
      }
    }

    // Else store ob[i] in result directly
    else {
      result[i] = ob[i];
    }
  }
  return result;
};

export const ControlValueAccessorProvider = (
  component: any
): Provider => {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => component),
    multi: true,
  };
};
